"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var core_1 = require("@angular/core");
var router_1 = require("@angular/router");
var forms_1 = require("@angular/forms");
var operators_1 = require("rxjs/operators");
var environment_1 = require("../../environments/environment");
var logger_service_1 = require("../core/logger.service");
var i18n_service_1 = require("../core/i18n.service");
var authentication_service_1 = require("../core/authentication/authentication.service");
require("./login.component.scss");
var log = new logger_service_1.Logger('Login');
var LoginComponent = /** @class */ (function () {
    function LoginComponent(router, formBuilder, i18nService, authenticationService) {
        var _this = this;
        this.router = router;
        this.formBuilder = formBuilder;
        this.i18nService = i18nService;
        this.authenticationService = authenticationService;
        this.version = environment_1.environment.version;
        this.isLoading = false;
        this.createForm();
        if (this.authenticationService.isAuthenticated()) {
            this.authenticationService.refreshToken().subscribe(function () {
                _this.navigateToPageBasedOnRole();
            });
        }
    }
    Object.defineProperty(LoginComponent.prototype, "currentLanguage", {
        get: function () {
            var languageCode = this.i18nService.language;
            return this.languages.find(function (l) { return l.code === languageCode; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LoginComponent.prototype, "languages", {
        get: function () {
            return this.i18nService.supportedLanguages;
        },
        enumerable: true,
        configurable: true
    });
    LoginComponent.prototype.ngOnInit = function () {
    };
    LoginComponent.prototype.login = function () {
        var _this = this;
        this.isLoading = true;
        this.authenticationService.login(this.loginForm.value)
            .pipe(operators_1.finalize(function () {
            _this.loginForm.markAsPristine();
            _this.isLoading = false;
        }))
            .subscribe(function (credentials) {
            log.debug(credentials.username + " successfully logged in");
            _this.navigateToPageBasedOnRole();
        }, function (error) {
            log.debug("Login error: " + error);
            _this.error = error;
        });
    };
    LoginComponent.prototype.setLanguage = function (language) {
        this.i18nService.language = language.code;
    };
    LoginComponent.prototype.createForm = function () {
        this.loginForm = this.formBuilder.group({
            username: ['', forms_1.Validators.required],
            password: ['', forms_1.Validators.required],
            remember: true
        });
    };
    LoginComponent.prototype.navigateToPageBasedOnRole = function () {
        if (this.authenticationService.hasRole("physician" /* PHYSICIAN */, "service_engineer" /* SERVICE_ENGINEER */, "admin" /* ADMIN */)) {
            this.router.navigate(['/patient-selection'], { replaceUrl: true });
        }
        else {
            this.router.navigate(['/data'], { replaceUrl: true });
        }
    };
    LoginComponent = tslib_1.__decorate([
        core_1.Component({
            selector: 'app-login',
            template: require('./login.component.html')
        }),
        tslib_1.__metadata("design:paramtypes", [router_1.Router,
            forms_1.FormBuilder,
            i18n_service_1.I18nService,
            authentication_service_1.AuthenticationService])
    ], LoginComponent);
    return LoginComponent;
}());
exports.LoginComponent = LoginComponent;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/app/login/login.component.ts
// module id = 275
// module chunks = 0